export default __webpack_public_path__ + "static/media/design-illustration.415c277c.svg";